const brandButtonSx = ({ palette: { brand, white } }) => ({
  backgroundColor: white.main,
  backgroundImage: "none",
  color: brand.main,
  border: `1px solid ${white.main}`,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: brand.focus,
    borderColor: brand.focus,
    color: white.main,
    boxShadow: "none",
  },
  "& .material-icons-round, & .MuiIcon-root": {
    color: "inherit",
  },
});

// Variante con bordo verde scuro
export const brandButtonOutlinedSx = (theme) => ({
  ...brandButtonSx(theme),
  "&&": {
    border: `1px solid ${theme.palette.brand.main}`,
  },
  "&&:hover": {
    borderColor: theme.palette.brand.focus,
  },
});


export const brandIconButtonSx = ({ palette: { brand, white } }) => ({
  backgroundColor: white.main,
  backgroundImage: "none",
  color: brand.main,
  border: `1px solid ${brand.main}`,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: brand.focus,
    borderColor: brand.focus,
    color: white.main,
  },
  "&:focus-visible": {
    outline: `2px solid ${brand.focus}`,
    outlineOffset: "2px",
  },
  "& .material-icons-round, & .MuiIcon-root": {
    color: "inherit",
  },
});

export const brandIconOnlySx = ({ palette: { brand }, functions: { rgba } }) => ({
  color: brand.main,
  "&:hover": {
    backgroundColor: rgba(brand.focus, 0.15),
  },
  "&:focus-visible": {
    outline: `2px solid ${brand.focus}`,
    outlineOffset: "2px",
  },
});

export const brandAnnullaButtonSx =({ palette: { brand }, functions: { rgba } }) => ({
  color: `${brand.main} !important`,borderColor: brand.main,
    "&:hover": { color: `${brand.main} !important`,borderColor: brand.main },
});


export const brandFabSx =({ palette: { brand, white }, functions: { rgba } }) => ({
    backgroundColor: white.main,
    color: brand.main,
    textTransform: "none",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: rgba(brand.focus, 0.15),
    },
    "&:focus-visible": {
      outline: `2px solid ${brand.focus}`,
      outlineOffset: "2px",
    },
  });

export default brandButtonSx;